'use client';

import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink, loggerLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { useState } from 'react';
import superjson from 'superjson';
import { type PlayerPortalsAppRouter } from '@r-and-a-shared-ui/randa-trpc-server';
import { getQueryClient, getUrl } from '../utils';

export const ppTrpc = createTRPCReact<PlayerPortalsAppRouter>();

let clientQueryClientSingleton: QueryClient = undefined!;

export const PPTrpcProvider = (
  props: Readonly<{
    children: React.ReactNode;
  }>,
) => {
  // NOTE: Avoid useState when initializing the query client if you don't
  //       have a suspense boundary between this and the code that may
  //       suspend because React will throw away the client on the initial
  //       render if it suspends and there is no boundary
  const queryClient = getQueryClient(clientQueryClientSingleton);
  const [trpcClient] = useState(() =>
    ppTrpc.createClient({
      links: [
        httpBatchLink({
          url: getUrl(),
          maxURLLength: 2048,
          transformer: superjson,
        }),
        loggerLink({
          enabled: opts =>
            process.env.NODE_ENV === 'development' ||
            (opts.direction === 'down' && opts.result instanceof Error),
        }),
      ],
    }),
  );

  return (
    <ppTrpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {props.children}
      </QueryClientProvider>
    </ppTrpc.Provider>
  );
};
